import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { IconButton } from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";
import { config } from "../../config/config";
import { apiList, invokeApi } from "../../services/apiServices";
import { Cookies } from "react-cookie";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 640 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 640, min: 0 },
    items: 1,
  },
};

const CustomLeftArrow = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        left: 0,
        zIndex: 10,
        backgroundColor: "rgba(255,255,255,0.8)",
        "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
        color: "#1A1A1A",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <ArrowBackIcon />
    </IconButton>
  );
};

const CustomRightArrow = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        right: 0,
        zIndex: 10,
        backgroundColor: "rgba(255,255,255,0.8)",
        "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
        color: "#1A1A1A",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <ArrowForwardIcon />
    </IconButton>
  );
};

export default function FeaturesCarousel() {
  const navigate = useNavigate();
  const [featureData, setFeatureData] = useState([]);

  const handleGetFeatures = async () => {
    const params = {};

    try {
      const response = await invokeApi(
        config.getMyCollege + apiList.getFeatures,
        params,
        Cookies
      );

      if (response?.status === 200) {
        setFeatureData(response.data.features || []);
      } else {
        console.error("Failed to fetch features:", response);
      }
    } catch (error) {
      console.error("Error fetching features:", error);
    }
  };

  useEffect(() => {
    handleGetFeatures();
  }, []);

  return (
    <Box sx={{ bgcolor: "#ffff", py: 6, px: { xs: 2, sm: 4, md: 10 } }}>
      <Box sx={{ maxWidth: "1440px", mx: "auto" }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography
            variant="h4"
            color="black"
            fontWeight="bold"
            sx={{ fontFamily: "Montserrat, sans-serif" }}
          >
            FEATURES
          </Typography>
          <Button
            variant="outlined"
            endIcon={<ArrowForwardIcon />}
            sx={{
              color: "white",
              borderColor: "white",
              borderRadius: "4px",
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 600,
            }}
            onClick={() => navigate("/features")}
          >
            VIEW ALL
          </Button>
        </Box>
        <Carousel
          swipeable
          draggable
          showDots={false}
          arrows={true}
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
          responsive={responsive}
          infinite
          autoPlay={false}
          keyBoardControl
          customTransition="transform 700ms ease-in-out"
          transitionDuration={700}
          containerClass="carousel-container"
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {Array.isArray(featureData) && featureData.map((item, index) => (
            <Card
              key={index}
              sx={{
                mx: 1,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                boxShadow: 0,
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
              onClick={() => navigate(`/feature/${item.ogUrl}`)}
            >
              <CardMedia
                component="img"
                image={item.featuredUrl}
                alt={item.featureTitle}
                sx={{
                  height: 250,
                  objectFit: "cover",
                  transition: "transform 0.5s ease",
                  "&:hover": {
                    transform: "scale(1.1)",
                  },
                }}
              />

              <CardContent sx={{ flexGrow: 1 }}>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  color="#1A1A1A"
                  sx={{ fontFamily: "Montserrat, sans-serif" }}
                >
                  {item.featureTitle}
                </Typography>
                <Typography
                  variant="body2"
                  color="green"
                  mt={2}
                  sx={{
                    textDecoration: "underline",
                    fontFamily: "Montserrat, sans-serif",
                  }}
                >
                  Read More
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Carousel>
      </Box>
    </Box>
  );
}
